import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AgendaSchedule, AppointmentSlot } from '../agenda-calendar/agenda-calendar.models'

/**
 * Shared appointment details panel — used inside oc-modal in agenda-calendar and inside
 * the dense-schedule-grid drawer. Pure presentation: takes the appointment + the list of
 * known schedules (to resolve schedule name), emits actions to the parent.
 */
@Component({
  selector: 'app-appointment-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './appointment-details.component.html',
  styleUrl: './appointment-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentDetailsComponent {
  @Input({ required: true }) appointment!: AppointmentSlot
  @Input() schedules: AgendaSchedule[] = []
  @Input() isLockedByOther = false

  @Output() historyClick = new EventEmitter<AppointmentSlot>()
  @Output() openAppointmentClick = new EventEmitter<AppointmentSlot>()

  protected get scheduleName(): string {
    return this.schedules.find((s) => s.id === this.appointment?.scheduleId)?.name ?? ''
  }

  protected get procedureNames(): string {
    return this.appointment?.procedures?.map((p) => p.name).join(', ') ?? ''
  }

  protected get statusLabel(): string {
    return this.appointment?.status?.name ?? ''
  }

  protected onHistory(): void {
    this.historyClick.emit(this.appointment)
  }

  protected onOpenAppointment(): void {
    this.openAppointmentClick.emit(this.appointment)
  }
}
